import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      affectingFactors: {
        policyholderIsVehicleOwner: null,
        policyholderTaxNumber: null,
        policyholderBirthday: null,
        vehicleYoungestDriverAge: null,
        vehicleOwnerIsPolicyholder: null,
        vehicleOwnerBirthday: null,
        availableFactors: [],
      },
    };
  },
  mounted() {
    this.affectingFactors = {
      ...this.affectingFactors,
      policyholderIsVehicleOwner: this.getAffectingFactorsPolicyholderIsVehicleOwner,
      policyholderTaxNumber: this.getAffectingFactorsPolicyholderTaxNumber,
      policyholderBirthday: this.getAffectingFactorsPolicyholderBirthday,
      vehicleYoungestDriverAge: this.getAffectingFactorsVehicleYoungestDriverAge,
      vehicleOwnerIsPolicyholder: this.getAffectingFactorsVehicleOwnerIsPolicyholder,
      vehicleOwnerBirthday: this.getAffectingFactorsVehicleOwnerBirthday,
      availableFactors: this.getAffectingFactorsAvailableFactors,
    };
  },
  computed: {
    ...mapGetters('affectingFactorsModule', [
      'getAffectingFactorsPolicyholderIsVehicleOwner', 'getAffectingFactorsPolicyholderTaxNumber',
      'getAffectingFactorsPolicyholderBirthday', 'getAffectingFactorsVehicleYoungestDriverAge',
      'getAffectingFactorsVehicleOwnerIsPolicyholder', 'getAffectingFactorsVehicleOwnerBirthday',
      'getAffectingFactorsAvailableFactors', 'hasAvailableAffectingFactor',
    ]),
  },
  methods: {
    ...mapActions('affectingFactorsModule', [
      'setAffectingFactorsPolicyholderIsVehicleOwner', 'setAffectingFactorsPolicyholderTaxNumber',
      'setAffectingFactorsPolicyholderBirthday', 'setAffectingFactorsVehicleYoungestDriverAge',
      'setAffectingFactorsVehicleOwnerIsPolicyholder', 'setAffectingFactorsVehicleOwnerBirthday',
      'setAffectingFactorsAvailableFactors', 'removeAffectingFactor',
    ]),

    affectingFactorsClear() {
      this.affectingFactors = {
        ...this.affectingFactors,
        policyholderIsVehicleOwner: null,
        policyholderTaxNumber: null,
        policyholderBirthday: null,
        vehicleYoungestDriverAge: null,
        vehicleOwnerBirthday: null,
      };
    },
  },
  watch: {
    'affectingFactors.policyholderIsVehicleOwner'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setAffectingFactorsPolicyholderIsVehicleOwner(newValue);
      }
    },
    'affectingFactors.policyholderTaxNumber'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setAffectingFactorsPolicyholderTaxNumber(newValue);
      }
    },
    'affectingFactors.policyholderBirthday'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setAffectingFactorsPolicyholderBirthday(newValue);
      }
    },
    'affectingFactors.vehicleYoungestDriverAge'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setAffectingFactorsVehicleYoungestDriverAge(newValue);
      }
    },
    'affectingFactors.vehicleOwnerIsPolicyholder'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setAffectingFactorsVehicleOwnerIsPolicyholder(newValue);
      }
    },
    'affectingFactors.vehicleOwnerBirthday'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setAffectingFactorsVehicleOwnerBirthday(newValue);
      }
    },
  },
};
